import React from 'react'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ModalBodyText } from './styled'

interface ConfirmInactiveToDraftModalProps {
  isOpen: boolean
  processing?: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmInactiveToDraftModal: React.FC<ConfirmInactiveToDraftModalProps> =
  ({ isOpen, processing = false, onClose, onConfirm }) => {
    const t = useTranslationRankmi({
      prefix: 'administration.courses.edit.confirmInactiveToDraftModal',
    })

    return (
      <Modal
        isOpen={isOpen}
        title={t('title')}
        isConfirmation
        maxwidth={560}
        maxheight={240}
        close={onClose}
        actions={
          <ModalButtons
            secondaryText={t('cancel')}
            secondaryAction={onClose}
            disableSecondaryButton={processing}
            primaryText={t('confirm')}
            primaryAction={onConfirm}
            disablePrimaryButton={processing}
            processing={processing}
          />
        }
      >
        <ModalBodyText>{t('body')}</ModalBodyText>
      </Modal>
    )
  }

export default ConfirmInactiveToDraftModal
